import { StrategyDetailsPageCommitmentsByInvestorQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { Loader } from '@/components/loaders/loader';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import guid from '@/shared/utils/guid';
import { formatPercentage } from '@/shared/utils/percentage';
import { TenantType } from '@trace-8/trace8-schema';

interface MobileTableInvestorProps {
  columns: TableColumns[];
  investorTableRows: StrategyDetailsPageCommitmentsByInvestorQuery['CommitmentsByInvestor']['investors'];
  loading: boolean;
  openInvestorDetailsPage: ({ investorId, entityId }: { investorId: string; entityId?: string }) => void;
}

const MobileTableInvestor = ({ columns, investorTableRows, loading, openInvestorDetailsPage }: MobileTableInvestorProps) => {
  const { user } = useAuth();

  if (loading) return <Loader />;

  const TableRow = ({ el }: { el: StrategyDetailsPageCommitmentsByInvestorQuery['CommitmentsByInvestor']['investors'][number] }) => {
    return (
      <MobileTableRowWrap key={guid()}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue onClick={() => openInvestorDetailsPage({ investorId: el.investor.id })} isRedirect>
            {el.investor.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.investorEntities}</MobileRowValue>
        </MobileRow>

        {user && user.tenant.type === TenantType.PLATFORM_MANAGER && (
          <MobileRow>
            <MobileRowTitle>{columns[2].title}</MobileRowTitle>
            <MobileRowValue>{el.tenant.name}</MobileRowValue>
          </MobileRow>
        )}

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.committedCapital}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.capitalCalled}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[5].title}</MobileRowTitle>
          <MobileRowValue>{formatPercentage(el.percentOfCapitalCalled)}</MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {investorTableRows.length ? (
        investorTableRows.map((el, index) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTableInvestor;
